import { useState } from 'react';
import * as Bootstrap from 'react-bootstrap';
import CustomToggle from '../blocks/CustomToggle';

const Accordion = ( props ) => {

    const { items } = props;

    const [chaveAberta, setChaveAberta] = useState(null);
    const lidarComSelecao = ( eventKey ) => {
        setChaveAberta( eventKey );
        console.log("A chave do item aberto é:", eventKey);
    };
    
    var _key = 0;

    return(
        <Bootstrap.Accordion onSelect={lidarComSelecao} defaultActiveKey="0">
            {items.map( item => {
                _key = _key + 1;
                return ( 
                <Bootstrap.Card key={item.id}>
                    <Bootstrap.Card.Header>
                        <CustomToggle eventKey={_key} icon="plus">{item.title}</CustomToggle>
                    </Bootstrap.Card.Header>
                    <Bootstrap.Accordion.Collapse eventKey={_key}>
                        <Bootstrap.Card.Body>
                            <span dangerouslySetInnerHTML={{ __html: item.content }} />
                        </Bootstrap.Card.Body>
                    </Bootstrap.Accordion.Collapse>
                </Bootstrap.Card>)
            })}
        </Bootstrap.Accordion>
    )


}

export default Accordion